export const luxPlusPricingConfigQueryKeys = {
  all: ['luxplus-pricing-configs'] as const,
  list: (vendorId: string | undefined) => [...luxPlusPricingConfigQueryKeys.all, vendorId] as const,
};
